// extracted by mini-css-extract-plugin
export default {"container":"uF-z","disabled":"vF-z","bgBlack":"wF-z","content":"xF-z","countdown":"yF-z","topCaption":"zF-z","topHeading":"AF-z","heading":"BF-z","copy":"CF-z"};